var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VRow',[_c('VCol',{attrs:{"cols":"12","md":"4"}},[_c('VSelect',{attrs:{"label":_vm.$t('stats.ui.status'),"items":_vm.status},model:{value:(_vm.selectedStatus),callback:function ($$v) {_vm.selectedStatus=$$v},expression:"selectedStatus"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }